export default {
  state: {
    priceData: null,
  },
  getters: {
    getPriceData(state) {
      return state.priceData;
    },
    getPrice(state, getters) {
      const priceData = getters.getPriceData;
      return priceData ? priceData.price : null;
    },
    getFormattedPrice(state, getters) {
      const price = getters.getPrice;
      return price ? price.formattedPrice : '';
    },
    getShowFormattedPrice(state, getters) {
      return !!getters.getFormattedPrice.length;
    },
    getSalePrice(state, getters) {
      const priceData = getters.getPriceData;
      return priceData ? priceData.salePrice : null;
    },
    getFormattedSalePrice(state, getters) {
      const salePrice = getters.getSalePrice;
      return salePrice ? salePrice.formattedPrice : '';
    },
    getShowFormattedSalePrice(state, getters) {
      return !!getters.getFormattedSalePrice.length;
    },
    getSavings(state, getters) {
      const priceData = getters.getPriceData;
      return priceData ? priceData.savings : null;
    },
    getFormattedSavings(state, getters) {
      const savings = getters.getSavings;
      return savings ? savings.formattedPrice : '';
    },
    getShowFormattedSavings(state, getters) {
      return !!getters.getFormattedSavings.length;
    },
  },
  mutations: {
    setPriceData(state, payload) {
      state.priceData = payload;
    },
  },
  actions: {
    setPriceInfo({ commit }, payload) {
      const { priceData } = payload;

      commit('setPriceData', priceData);
    },
  },
};
